import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchSkills = createAsyncThunk(
    'masters/fetchSkills',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/skill`);
            return { success: true, message: "Skills fetched successfully!", data: response?.data?.skills };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const createSkill = createAsyncThunk(
    'masters/createSkill',
    async (formData) => {
        try {
            const response = await myAxios.post(`/masters/skill`,  formData);

            return { success: true, message: "Skill added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateSkill = createAsyncThunk(
    'masters/updateSkill',
    async (formData) => {
        try {
            const response = await myAxios.put(`/masters/skill/${formData.skillId}`, formData);

            return { success: true, message: "Skill updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteSkill = createAsyncThunk(
    'masters/deleteSkill',
    async (query) => {
        try {
        const response = await myAxios.delete(`/masters/skill/${query.skillId}`);

            return { success: true, message: "Skill deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


const skillsSlice = createSlice({
    name: 'skills',
    initialState,
    reducers: {
        clearSkillsData: state => {
            state.data = [];
        },
        setSkillsData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const skillsReducer = skillsSlice.reducer;
export const { clearSkillsData, setSkillsData } = skillsSlice.actions;

export const selectSkillsData = (state) => state.skills.data;
